import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IInitialState {
    isChecked: boolean;
}

const initialState: IInitialState = {
    isChecked: true,
};

const filterOnOffSlice = createSlice({
    name: 'filterOnOFf',
    initialState,
    reducers: {
        setFilterChecker: (state: IInitialState, action: PayloadAction<boolean>) => {
            state.isChecked = action.payload;
        },
    },
});

export default filterOnOffSlice.reducer;
export const { setFilterChecker } = filterOnOffSlice.actions;
